import { render, staticRenderFns } from "./importOrder.vue?vue&type=template&id=624ac1d3&scoped=true&"
import script from "./importOrder.vue?vue&type=script&lang=js&"
export * from "./importOrder.vue?vue&type=script&lang=js&"
import style0 from "./importOrder.vue?vue&type=style&index=0&id=624ac1d3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ac1d3",
  null
  
)

export default component.exports